/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Sinp_Label_ReasonInputs */

const vi_sinp_label_reason = /** @type {(inputs: Sinp_Label_ReasonInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Lý do nhập`)
};

/**

* @param {Sinp_Label_ReasonInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const sinp_label_reason = /** @type {((inputs?: Sinp_Label_ReasonInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Sinp_Label_ReasonInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_sinp_label_reason(inputs)
});